import { useMemo } from "react";
import intl from "react-intl-universal";
import {
  TbChartPie,
  TbCircleCheck,
  TbCreditCard,
  TbReceiptRefund,
  TbWallet,
} from "react-icons/tb";
import { SummaryCard } from "../../../../../Components/Atoms/SummaryCard";
import { EMPTY_BAAS_HOME_CARDS_METRICS } from "../baasHomeMetrics";

const formatCount = (value) =>
  new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(value);

const formatPercent = (value, fractionDigits = 1) =>
  `${new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)}%`;

/** Issuer KPIs as spaced SummaryCards (matches Crédito KPI grid). */
export const BaasCartoesKpiCards = ({
  titleKey = "baas.home.cardsSection",
  metrics: metricsOverride = null,
} = {}) => {
  const cardsMetrics = useMemo(
    () => metricsOverride || EMPTY_BAAS_HOME_CARDS_METRICS,
    [metricsOverride],
  );

  const metrics = useMemo(
    () => [
      {
        key: "totalCards",
        icon: TbCreditCard,
        title: intl.get("baas.home.totalCards.title"),
        value: formatCount(cardsMetrics.totalCards),
        subtext: intl.get("baas.home.totalCards.subtext"),
      },
      {
        key: "activeCards",
        icon: TbWallet,
        title: intl.get("baas.home.activeCards.title"),
        value: formatCount(cardsMetrics.activeCards),
        subtext: intl.get("baas.home.activeCards.subtext"),
      },
      {
        key: "activationRate",
        icon: TbChartPie,
        title: intl.get("baas.home.activationRate.title"),
        value: formatPercent(cardsMetrics.activationRate),
        subtext: intl.get("baas.home.activationRate.subtext"),
      },
      {
        key: "approvalRate",
        icon: TbCircleCheck,
        title: intl.get("baas.home.approvalRate.title"),
        value: formatPercent(cardsMetrics.approvalRate),
        subtext: intl.get("baas.home.approvalRate.subtext"),
      },
      {
        key: "chargebackRatio",
        icon: TbReceiptRefund,
        title: intl.get("baas.home.chargebackRatio.title"),
        value: formatPercent(cardsMetrics.chargebackRatio, 2),
        subtext: intl.get("baas.home.chargebackRatio.subtext"),
      },
    ],
    [cardsMetrics],
  );

  return (
    <section className="min-w-0 w-full">
      <p className="dashboard-section-label mb-3">{intl.get(titleKey)}</p>
      <div className="dashboard-card-grid">
        {metrics.map((metric) => (
          <SummaryCard
            key={metric.key}
            icon={metric.icon}
            title={metric.title}
            value={metric.value}
            footerLabel={metric.subtext}
          />
        ))}
      </div>
    </section>
  );
};
